"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Description = exports.Title = exports.DescriptionContainer = exports.TitleContainer = exports.OptionContainer = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -8px;\n  margin-right: -8px;\n\n  ", " {\n    margin-left: -16px;\n    margin-right: -16px;\n  }\n"])), _widths.mediaQueries.desktop);

exports.Container = Container;
Container.displayName = 'Container';

var OptionContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: 8px;\n  margin-right: 8px;\n  height: 90px;\n  width: calc(50% - 16px);\n  border: ", ";  \n  box-sizing: border-box;\n  box-shadow: ", ";\n  border-radius: 4px;\n  background-color: ", ";\n  cursor: pointer;\n\n  ", " {\n    margin-left: 16px;\n    margin-right: 16px;\n    width: calc(50% - 32px);\n    max-width: 200px;\n  }\n"])), function (props) {
  return "1px solid ".concat(props.selected ? _palette.palette.primary : _palette.palette.lightGrey);
}, function (props) {
  return props.selected ? '0px 2px 5px rgba(0, 0, 0, 0.15)' : null;
}, _palette.palette.white, _widths.mediaQueries.desktop);

exports.OptionContainer = OptionContainer;
OptionContainer.displayName = 'OptionContainer';

var TitleContainer = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: row;\n  margin-top: 16px;\n  margin-left: 10px;\n  margin-right: 8px;\n"])));

exports.TitleContainer = TitleContainer;
TitleContainer.displayName = 'TitleContainer';

var DescriptionContainer = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: row;\n  margin-top: 8px;\n  margin-left: 32px;\n  margin-bottom: 16px;\n  margin-right: 8px;\n"])));

exports.DescriptionContainer = DescriptionContainer;
TitleContainer.displayName = 'DescriptionContainer';

var Title = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  font-style: normal;\n  font-weight: ", ";\n  font-size: 16px;\n  line-height: 20px;\n  color: ", ";\n"])), _widths.font.semi, _palette.palette.bobBlack);

exports.Title = Title;
Title.displayName = 'Title';

var Description = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 15px;\n  color: ", ";\n"])), _palette.palette.bobBlack);

exports.Description = Description;
Description.displayName = 'Description';